import { createContext, useEffect, useState, useContext, useMemo } from "react";
import { IAuthProvider, IContext, IUser } from "./types";
import {
  setAccessTokenLocalStorage,
  setUserAuthLocalStorage,
  handleUserLogOut,
} from "./utils";
import { LoginRequest } from "../services/UserAuthService";

import { UserPreferenceContext } from "../context/UserPreferenceContext";
import {
  IsAuthenticated,
  checkUserIsLogged,
  handleDisconnectedUserAux,
} from "./AuthProviderUtils";

export const AuthContext = createContext<IContext>({} as IContext);

export const AuthProvider = ({ children }: IAuthProvider) => {
  const [user, setUser] = useState<IUser | null>({
    rememberLogin: false,
    tosAgree: false,
  });
  const { userPreference, userAuthenticated, setUserAuthenticated, doUserPreference } =
    useContext(UserPreferenceContext);
  useEffect(() => {
    checkUserIsLogged(setUser, userAuthenticated, setUserAuthenticated);
    if (userPreference == null && userAuthenticated) {
      doUserPreference();
    }
  }, [userAuthenticated]);

  async function authenticate(
    username: string,
    password: string,
    countryId: number,
    language: string,
    rememberLogin: boolean,
    tosAgree: boolean
  ) {
    const response = await LoginRequest(
      username,
      password,
      countryId,
      language
    );
    localStorage.removeItem('passwordChangeRedirected');
    if (response) {
      const payload: IUser = {
        token: response.access_token,
        username: response.userName,
        rememberLogin: rememberLogin,
        tosAgree: rememberLogin ? true : tosAgree,
        //password: password,
      };
      if (
        response?.access_token !== null &&
        response?.access_token !== undefined &&
        response?.access_token !== ""
      ) {
        setAccessTokenLocalStorage(response.access_token);
        setUserAuthLocalStorage(payload);
        setUser(payload);
        await doUserPreference();
        setUserAuthenticated(true);
      }
    }

    return response;
  }

  function logout() {
    setUser(null);
    handleUserLogOut();
  }

  function setUserAuth(user: IUser) {
    setUser(user);
  }

  function handleDisconnectedUser(data: any, userIsAuthenticated: boolean) {
    let objParam = {
      data,
      userAuthenticated,
      userIsAuthenticated,
      setUser,
      setUserAuthenticated,
      user,
      userPreference,
    };
    handleDisconnectedUserAux(objParam);
  }

  const objMemoProvider = useMemo(
    () => ({
      ...user,
      authenticate,
      logout,
      setUserAuth,
      IsAuthenticated,
      handleDisconnectedUser,
    }),
    [user]
  );

  return (
    <AuthContext.Provider value={objMemoProvider}>
      {children}
    </AuthContext.Provider>
  );
};